import React from "react"
import { observer } from "mobx-react"

import store from "../../../../store"
import { Styles } from "../../../../config"
import styles from "./styles"

import { Stack, Button } from "@mui/material"
import { Icon } from "../../../../typo-components"

const ButtonRow= ({ entries, updateEntries, entry, row }) => {
	const button = row?.buttonConfig({
		data: entries,
		updateData: updateEntries,
		cell: { row: { original: entry } }
	})

	if (!button) return null
	else if (button?.disabled) return null

	const label = row?.Header
	const icon = button?.iconConfig?.name
	const color = button?.color || "primary"

	const ButtonIcon = () => <Icon name={icon} color={Styles.Color.white} style={{ width: "auto", height: "auto" }} />

	return (
		<Stack sx={styles.container}>
			<Button
				variant="contained"
				disableElevation
				startIcon={<ButtonIcon />}
				sx={styles.button({ color })}
				onClick={(event) => {
					if (button?.popoverConfig) {
						store.setConfirmConfig({
							anchor: event.target,
							text: button?.popoverConfig?.text || "",
							color,
							onCancel: () => store.setConfirmConfig({}),

							onConfirm: () => {
								store.setConfirmConfig({})
								button?.onClick()
							}
						})
					} else button?.onClick()
				}}
			>
				{label}
			</Button>
		</Stack>
	)
}

export default observer(ButtonRow)
